/*eslint-disable */
import CreateGroup from './CreateGroup';

export default CreateGroup;
